import { defMathOp } from "./compile/emit.js";
const [div, div2, div3, div4] = defMathOp("/");
export {
  div,
  div2,
  div3,
  div4
};
